export default __webpack_public_path__ + "static/media/integration.e8f5d792.svg";